import useCommonProductQuery from "@repo/shopify/queries/useProductQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useProduct() {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonProductQuery({
    lang,
    openToast,
  });
}
